import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';
import type { ApiResponse } from '../../types/api';
import type {
  DeleteNotificationRequest,
  UpdateReadStatusRequest,
  GetNotificationsRequest,
  NotificationCountResponse,
} from './notificationTypes';

const notificationApi = {
  deleteNotification: (
    payload: DeleteNotificationRequest,
  ): Promise<ApiResponse<void>> =>
    apiClient.delete<void>(API_ENDPOINTS.NOTIFICATION.NOTIFICATION, {
      data: payload,
    }),

  deleteAllNotifications: (): Promise<ApiResponse<void>> =>
    apiClient.delete<void>(API_ENDPOINTS.NOTIFICATION.DELETE_ALL_NOTIFICATIONS),

  updateReadStatus: (
    payload: UpdateReadStatusRequest,
  ): Promise<ApiResponse<void>> =>
    apiClient.post<void>(API_ENDPOINTS.NOTIFICATION.UPDATE_READ_STATUS, payload),

  getNotifications: (
    payload: GetNotificationsRequest,
  ): Promise<ApiResponse<any>> =>
    apiClient.post<any>(API_ENDPOINTS.NOTIFICATION.GET_NOTIFICATIONS, payload),

  getNotificationCount: (): Promise<ApiResponse<NotificationCountResponse>> =>
    apiClient.get<NotificationCountResponse>(API_ENDPOINTS.NOTIFICATION.COUNT),
};

export default notificationApi;
